<template>
  <div>
    <div class="list">
      <list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <comment :tabshow="true" :list="list"/>
        
      </list>
    </div>
  </div>
</template>

<script>
/**
@description:收到的评价
@createTime:2021-09-03
@create:wq
*/
import comment from "../../../components/comment.vue";
import { List } from "vant";

export default {
  name: "",
  props: {},
  components: { comment, List },
  data() {
    return {
      loading: false,
      finished: false,
      page:1,
      list:[],
      tid:''
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.tid = this.$route.query.tid;
  },
  methods: {
    onLoad() {
      this.getList();
      this.page++;
    },
    getList() {
      this.api.getMyEvaluate({tid:this.tid,page:this.page}).then((res) => {
        console.log(res.data.data);
        this.list = [...this.list, ...res.data.data];
        if (res.data.to < res.data.per_page) {
          this.loading = true;
          this.finished = true;
        } else {
          this.loading = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  margin: 0 0.24rem;
  padding-top: 0.48rem;
}
</style>
